import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery} from '@apollo/react-hooks'
import {
  PartnerByIdCounts,
  PartnerByIdCountsVariables
} from '../../_generated/PartnerByIdCounts'

export const QUERY = gql`
query PartnerByIdCounts($id: ID!){
  partners {
    byId(id: $id) {
      id
      counts {
        sbibs
        bibs
        ibs
        clients
      }
    }
  }
}`

export type Q = PartnerByIdCounts
export type V = PartnerByIdCountsVariables
export type R = Q['partners']['byId']['counts']

export const parseData = (data: Q): R => {
  return get(data, p => p.partners.byId.counts)
}

export function Use(partnerId: string) {
  const query = useQuery<Q, V>(
    QUERY,
    {
      variables: {
        id: partnerId,
      }
    }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
